export const _EmptyQuery = Object.freeze({ where: {} });
export const maxBatch = 500;
//# sourceMappingURL=consts.js.map